import { ModelRow, ModelSearchFilter } from "@mcleod/core";
import { DataSource, DataSourceAction } from "../databinding/DataSource";
import { Event, EventListener } from "./Event";

export interface DataSourceExecutionListener extends EventListener<DataSourceExecutionEvent> {
}

export class DataSourceExecutionEvent extends Event<DataSource> {
    private _action: DataSourceAction;
    private _isBefore: boolean;
    private _filter: any;
    private _data: ModelRow;

    constructor(dataSource: DataSource, action: DataSourceAction, isBefore: boolean, filter?: any) {
        super(dataSource, null);
        this._data = dataSource.data[0];
        this._action = action;
        this._isBefore = isBefore;
        this.filter = filter;
    }

    public get dataSource(): DataSource {
        return this.target;
    }

    public getAction() {
        return this._action;
    }

    public isBefore() {
        return this._isBefore;
    }

    public isAfter() {
        return !this.isBefore();
    }

    public get filter(): any {
        return this._filter;
    }

    public set filter(value: any) {
        this._filter = ModelSearchFilter.resolveData(value);
    }

    public get data(): ModelRow {
        return this._data;
    }
}
